import { Container } from "@mui/material"
import { AdjudicationSolvedOperation, AdjudicatorDecision } from "neurotec-megamatcherid-management-client-adjudicator";
import { useSnackbar } from "notistack";
import { useCallback, useContext, useEffect, useState } from "react";
import DataTable, { HeadCell, IDataTableId } from "../../../components/Misc/DataTable/DataTable";
import DatatableFooter from "../../../components/Misc/DataTable/DatatableFooter";
import { IAdjudicatorDecisionFilter } from "../../../Store/Adjudication/types";
import { APIsContext } from "../../../Store/APIs/context";
import { NavigationContext } from "../../../Store/Navigation/context";
import { setLoading } from "../../../Store/Navigation/reducer";
import AdjudicationOverviewDialog from "../components/AdjudicationOverviewDialog";
import AdjudicationDecisionSolvedFilter from "../../../components/Filter/AdjudicationDecisionSolvedFilter";

const headCells: HeadCell[] = [
    {
        id: 'FILTER_ADJUDICATOR_DECISION_DATE',
        align: 'left',
        disablePadding: false,
        label: 'Date',
        width: "30%"
    },
    {
        id: 'FILTER_ADJUDICATOR_DECISION_TYPE_OF_ATTACK',
        align: 'left',
        disablePadding: false,
        label: 'Type of attack',
        width: "35%"
    },
    {
        id: 'FILTER_ADJUDICATOR_DECISION_DECISION',
        align: 'left',
        disablePadding: false,
        label: 'Decision',
        width: "35%"
    },
];

const AdjudicationDecisionSolvedTab: React.FC = () => {

    const { enqueueSnackbar } = useSnackbar();
    const navigationDispatch = useContext(NavigationContext).dispatch
    const apisState = useContext(APIsContext).state
    const [decisions, setDecisions] = useState<AdjudicatorDecision[]>([])
    const [decisionCount, setDecisionCount] = useState<number | undefined>(undefined);
    const [selected, setSelected] = useState<IDataTableId[]>([]);
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(20)
    const [adjudicatorDecisionFilter, setAdjudicatorDecisionFilter] = useState<IAdjudicatorDecisionFilter>({})
    const [selectedAdjudication, setSelectedAdjudication] = useState<AdjudicationSolvedOperation>();
    const [showSolvedDialog, setShowSolvedDialog] = useState(false)

    const fetchAdjudicatorDecision = useCallback(async () => {
        try {
            navigationDispatch(setLoading(true))
            apisState.AdjudicationApi.getAdjudicatorDecisions({page: page, size: perPage, ...adjudicatorDecisionFilter}).then(res => {
                setDecisions(res.data)
                navigationDispatch(setLoading(false))
            }).catch(e => {
                console.log(e)
                enqueueSnackbar(e.message, {variant: "error"})
                navigationDispatch(setLoading(false))
            })

            apisState.AdjudicationApi.getAdjudicatorDecisionsCount(adjudicatorDecisionFilter).then(res => {
                setDecisionCount(res.data)
            }).catch(e => {
                setDecisionCount(0)
                console.log(e)
                enqueueSnackbar(e.message, {variant: "error"})
            })
        } catch (error: any) {
            console.log(error)
            enqueueSnackbar(error.message, {variant: "error"})
        }
    }, [page, perPage, apisState.AdjudicationApi, adjudicatorDecisionFilter, enqueueSnackbar, navigationDispatch])

    useEffect(() => {
        fetchAdjudicatorDecision();
    }, [apisState.AdjudicationApi, adjudicatorDecisionFilter, page, perPage, fetchAdjudicatorDecision])
    
    const handleDecisionClick = (decision: AdjudicatorDecision) => {
        if (decision && decision.uuid) {
            apisState.AdjudicationApi.getAdjudicationSolved({uuid: decision.uuid}).then(res => {
                setSelectedAdjudication(res.data)
                setShowSolvedDialog(true)
            }).catch(e => {
                setSelectedAdjudication(undefined)
                enqueueSnackbar(e.message, {variant: "error"})
            })
        }
    }
    
    const handlePageChange = (event: React.ChangeEvent<unknown> | undefined, newPage: number) => {
        setPage(newPage)
    }
    
    const handleFilterChange = (filter: IAdjudicatorDecisionFilter) => {
        setPage(1)
        setDecisionCount(undefined)
        setAdjudicatorDecisionFilter(filter)
    }

    return (
        <>
        <Container maxWidth="xl" sx={{ display: "flex", flexDirection: "column" }} >
            <AdjudicationDecisionSolvedFilter
                filter={adjudicatorDecisionFilter}
                onFilterApply={handleFilterChange}
            />
            <DataTable
                data={decisions}
                filter={adjudicatorDecisionFilter}
                onFilterChange={handleFilterChange}
                headCells={headCells}
                title={"Pending adjudications"}
                dateName={"date"}
                setSelected={setSelected}
                selected={selected}
                type="adjudicator-decision"
                onRowClick={handleDecisionClick}
            />
            <DatatableFooter
                page={page}
                handlePageChange={handlePageChange}
                count={decisionCount}
                perPage={perPage}
                setPerPage={setPerPage}
                label='Adjudications'
            />
        </Container>
        {selectedAdjudication &&
        (<AdjudicationOverviewDialog
            disableAction
            open={showSolvedDialog}
            onClose={() => setShowSolvedDialog(false)}
            adjudication={selectedAdjudication}
        />)}
        </>
    )
}

export default AdjudicationDecisionSolvedTab